import React from "react";
import Link from "next/link";
import Linkify from "react-linkify";
import { assertsString } from "~/submodules/assertsString";

export const CustomLinkify = ({ content }) => {
  const url = process.env.NEXT_PUBLIC_SERVICE_URL;
  assertsString(url);

  const componentDecorator = (href: string, text: string, key: number) =>
    !text.indexOf(url) ? (
      <Link key={key} href={text.replace(url, "")}>
        {text}
      </Link>
    ) : (
      <a key={key} href={href} target="_blank" rel="noopener noreferrer">
        {text}
      </a>
    );

  return <Linkify componentDecorator={componentDecorator}>{content}</Linkify>;
};
